/* RESPONSIBLE TEAM: team-inbox */
import {
  type RenderableData,
  type LinkedTicketWireFormat,
  LinkedTicket,
} from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import AdminSummary, { type AdminSummaryWireFormat } from 'embercom/objects/inbox/admin-summary';
import { EntityType } from 'embercom/models/data/entity-types';
import { Upload, type UploadWireFormat } from 'embercom/objects/inbox/renderable/upload';
import { type TranslationStatus } from 'embercom/objects/inbox/renderable-data';

interface AdminNoteWireFormat {
  renderable_type: RenderableType;
  blocks: Array<object>;
  admin_summary: AdminSummaryWireFormat;
  uploads?: Array<UploadWireFormat>;
  linked_ticket?: LinkedTicketWireFormat;
  translation_status?: string;
}

export default class AdminNote implements RenderableData {
  readonly renderableType: RenderableType = RenderableType.AdminNote;
  readonly blocks: Array<object>;
  readonly adminSummary: AdminSummary;
  readonly uploads?: Array<Upload>;
  readonly linkedTicket?: LinkedTicket;
  readonly translationStatus?: TranslationStatus | string;

  get teammate() {
    return this.adminSummary;
  }

  get creatingEntity() {
    return { type: EntityType.Admin, id: this.adminSummary.id, object: this.teammate };
  }

  get styles() {
    return {
      backgroundColor: 'bg-notice-container',
      textColor: 'text-default',
      backgroundColorHover: 'bg-notice-container-emphasis',
    };
  }

  get ticketStyles() {
    return {
      backgroundColor: 'bg-transparent',
      textColor: 'text-default',
      backgroundColorHover: 'bg-neutral-container',
    };
  }

  constructor(
    blocks: Array<object>,
    adminSummary: AdminSummary,
    uploads?: Array<Upload>,
    linkedTicket?: LinkedTicket,
    translationStatus?: TranslationStatus | string,
  ) {
    this.blocks = blocks;
    this.adminSummary = adminSummary;
    this.uploads = uploads || [];
    this.linkedTicket = linkedTicket;
    this.translationStatus = translationStatus;
  }

  static deserialize(json: AdminNoteWireFormat): AdminNote {
    let adminSummary = AdminSummary.deserialize(json.admin_summary);
    let linkedTicket = json.linked_ticket
      ? LinkedTicket.deserialize(json.linked_ticket)
      : undefined;
    return new AdminNote(
      json.blocks,
      adminSummary,
      json.uploads?.map(Upload.deserialize),
      linkedTicket,
      json.translation_status,
    );
  }
}
